import { render, staticRenderFns } from "./EvalDocenteAdm.vue?vue&type=template&id=3a4449db"
import script from "./EvalDocenteAdm.vue?vue&type=script&lang=js"
export * from "./EvalDocenteAdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports